<template>
  <div>
    <h1 class="text-3xl mb-4">Services</h1>

    <table class="mb-4 w-full">
      <thead>
        <tr>
          <td class="py-3 px-2 font-semibold text-center">id</td>
          <td class="py-3 px-2 font-semibold text-center">slug</td>
          <td class="py-3 px-2 font-semibold">nom du service</td>
          <td class="py-3 px-2 font-semibold" width="1%"></td>
          <td class="py-3 px-2 font-semibold" width="1%"></td>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(service, index) of services"
          :key="index"
          :class="{ 'bg-gray-100': !(index % 2) }"
        >
          <td class="py-2 px-2 text-center">
            {{ service.id }}
          </td>

          <td class="py-2 px-2 font-mono text-center">
            {{ service.slug }}
          </td>

          <td class="py-2 px-2">
            {{ service.name }}
          </td>

          <td class="py-2 px-2">
            <router-link
              :to="`/services/${service.id}/modifier`"
              class="bg-blue-500 text-white px-2 py-1 rounded shadow"
            >
              modifier
            </router-link>
          </td>
        </tr>
      </tbody>
    </table>

    <router-link
      to="/services/nouveau"
      class="bg-blue-500 hover:bg-blue-600 px-4 py-2 rounded text-white shadow float-right"
      tag="button"
    >
      Nouveau service
    </router-link>
  </div>
</template>

<script>
export default {
  data() {
    return {
      services: []
    }
  },

  async mounted() {
    const { data } = await this.$axios.get('/services')

    this.services = data
  }
}
</script>
